import { useCallback, useEffect, useState } from "react";

/** True when viewport is wider than tall (native/tablet landscape). */
export function useLandscapeOrientation(): boolean {
  const [landscape, setLandscape] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia("(orientation: landscape)").matches;
  });

  const update = useCallback(() => {
    setLandscape(window.matchMedia("(orientation: landscape)").matches);
  }, []);

  useEffect(() => {
    update();
    const mq = window.matchMedia("(orientation: landscape)");
    mq.addEventListener("change", update);
    window.addEventListener("resize", update);
    return () => {
      mq.removeEventListener("change", update);
      window.removeEventListener("resize", update);
    };
  }, [update]);

  return landscape;
}
